import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './../services/auth.service';
import { ConstantsService } from '../services/constants.service';
import { Router } from '@angular/router';
import { SubfolderService } from '@core/services/subfolder.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	constructor(
		private readonly authService: AuthService,
		private readonly constantService: ConstantsService,
		private readonly subfolderService: SubfolderService,
		private readonly router: Router
	) { }

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		const token = this.authService.getToken();

		// Determine the API URL based on the current path
		let apiUrl: string = this.constantService.API_URL;

		// Build proper Referer URL with the detected subfolder
		const origin = location.origin; // e.g., "https://beta.precisioncsrms.com"
		const subfolder = this.subfolderService?.subfolder || '';
		// Format proper referer with origin and subfolder if present
		let referer = subfolder ? `${origin}/${subfolder}/` : `${origin}/`;

		// Create custom headers object
		const headers: any = {
			// Referer: referer,
			'X-Referer': referer
		};

		if (token) {
			request = request.clone({
				url: `${apiUrl}/${request.url}`,
				setHeaders: {
					Authorization: `Bearer ${token}`,
					...headers
				}
			});
		} else {
			request = request.clone({
				url: `${apiUrl}/${request.url}`,
				setHeaders: headers
			});
		}

		return next.handle(request);
	}
}
